<template>
  <div :class="{'pointer-cursor': broadcastId}" style="height: 100%;background-color: #fff;" @mousemove="mouseover = true" @mouseleave="mouseover = false">

    <el-dialog  :visible.sync="dialogVisible" title="" top="5vh"  width="98%" class="call-test-results-dialog" @close="setVendorDestinationStatus" :append-to-body="true">
      <callTestResultsTable v-if="dialogVisible" :callTestRequest="broadcast" :broadcastPublicId="broadcastPublicId" :liveDataResults='liveDataResults' :numberOfCalls="number_of_calls" :testFinalStatus="testFinalStatus"></callTestResultsTable>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="vendorDestinationStatusDialogVisible" title="" top="4vh" :append-to-body="true"  width="300px" class="call-test-results-dialog">
      <vendorDestinationStatus v-if="vendorDestinationStatusDialogVisible && status == 1" :broadcast="{id: broadcastId}" @closeModel="closeVendorDestinationStatus"></vendorDestinationStatus>
    </el-dialog>

    <div v-if="!mouseover || !broadcastId" @mousemove="mouseover = true" @mouseleave="mouseover = false">
      <callTestStatusViewer :callTestStatus="(status)? status : 0" :text="time" style="height: 49px;font-size: 11px; padding-top:10px;"></callTestStatusViewer>
    </div>
    <div v-else-if="mouseover && broadcastId" @click="openDialog" class="h-100">
      <i class="el-icon-view" style="font-size: 21px;padding-top: 15px"></i>
    </div>
  </div>
</template>

<script>


export default {
  components: {
    callTestStatusViewer: () => import('@/components/call-test-status-viewer/View'),
    callTestResultsTable: () => import('@/components/call-test-results-table/View'),
    vendorDestinationStatus: () => import('@/modules/voip-testing-panel/vendor-destination-status/View'),
  },
  props: {
    time: {
      required: true
    },
    status: {
      required: true
    },
    broadcastId: {
      required: false
    },
    broadcastPublicId: {
      required: false
    },
    rateKey: {
      required: true
    },
    destKey: {
      required: true
    },
    afterSettingNewStatus: {
      required: true
    }
  },
  data() {
    return {
      testFinalStatus: 0,
      number_of_calls: -1,
      isChecked: null,
      dialogVisible: false,
      mouseover: false,
      broadcast: null,
      liveDataResults: [],
      vendorDestinationStatusDialogVisible: false,
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
    }
  },
  beforeMount() {
    this.isChecked = this.checked
  },
  methods: {
    ...$mapActions('voip-testing-panel-api', {
      getBroadcastCdr: 'getBroadcastCdr'
    }),
    getBroadcast () {
      this.dialogVisible = true
      this.getBroadcastCdr({id: this.broadcastId}).then(response => {
        let broadcast = response.data
        this.broadcast = broadcast
        if (typeof broadcast == 'string') {
          if (broadcast != 'No Records') {
            broadcast = 'Error in Call'
          }
          this.number_of_calls = -1
          this.liveDataResults = broadcast
          this.testFinalStatus = 0
        } else {
          this.liveDataResults = JSON.parse(broadcast.cdr_json)
          this.number_of_calls = broadcast.number_of_calls
          this.testFinalStatus = broadcast.system_call_test_status_id
        }
        /*this.agGrid.rowData = cdrRecords;
        this.recordsCounter = cdrRecords.length;
        this.amReady = true*/
      })
    },
    openDialog() {
      this.getBroadcast()
    },
    setVendorDestinationStatus () {
      if (this.status == "1" && !this.isUserCustomer) {
        this.vendorDestinationStatusDialogVisible = true
      }
    },
    closeVendorDestinationStatus (newStatus) {
      this.vendorDestinationStatusDialogVisible = false
      if (this.status == 1 && newStatus != 1) {
        this.afterSettingNewStatus(this.destKey, this.rateKey, newStatus)
      }
    },
  }
}
</script>
